import Axios from "axios"

// 创建Axios实例
let instance = Axios.create();

instance.defaults.withCredentials = false;
instance.defaults.timeout = 60000;
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded";
instance.defaults.headers.get['Content-Type'] = "application/x-www-form-urlencoded";
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    (config) => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        // const token = "Bearer " + store.state.userInfo.accessToken;
        // token && (config.headers.authorization = token);
        return config;
    },
    error => Promise.error(error)
)
// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    (res) => {
        // 设置post请求头
        instance.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded;charset=UTF-8";
        instance.defaults.headers.get['Content-Type'] = "application/x-www-form-urlencoded;charset=UTF-8";
        if (res.status === 200) {
            if (res.data.code === 200) {
                return Promise.resolve(res.data)
            } else {
                return Promise.reject(res)
            }
        } else {
            return Promise.reject(res)
        }
    },
    // 请求失败
    (error) => {
        const {response} = error;
        if (response) {
            return Promise.reject(response);
        } else {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
            if (!window.navigator.onLine) {
                return Promise.reject(response);
            } else {
                return Promise.reject(response);
            }
        }
    });

export default instance;
